import React from 'react';
import TelegramIcon from '../icons/TelegramIcon'
import '../../css/telegram-join-button.css'
function TelegramJoinButton(props){
  return (
    <>
			{props.size === 'large' &&
				<div
					className="telegram-join-button"
					style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}
					onClick={() => { window.open(props.shareLink, "_blank"); }}
				>
					<span style={{ flexShrink: 0 }}>
						<TelegramIcon size={props.iconSize} theme='dark'></TelegramIcon>
					</span>
					<span style={{ whiteSpace: 'nowrap' }}>Join @{props.channelName} Channel</span>
				</div>
			}
			{props.size === 'small' &&
				<div
					className="telegram-join-button-small"
					style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}
					onClick={() => { window.open(props.shareLink, "_blank"); }}
				>
					<span style={{ flexShrink: 0 }}>
						<TelegramIcon size={props.iconSize} theme='dark'></TelegramIcon>
					</span>
					<span style={{ whiteSpace: 'nowrap' }}>Join @{props.channelName}</span>
				</div>
			}
    </>
  );
};

TelegramJoinButton.defaultProps = {
	channelName: 'CryptoWaves',
	shareLink: 'https://t.me/cryptowavesapp',
	size: 'large',
	iconSize: 20
};

export default TelegramJoinButton;
